<template>
  <el-dialog
    v-model="dialogVisible"
    title="搜索结果"
    width="60%"
    :before-close="handleClose"
  >
    <div v-if="results.length === 0" class="no-results">
      未找到匹配的结果
    </div>
    <div v-else class="search-results">
      <div v-for="(result, index) in results" :key="index" class="result-item">
        <div class="result-header">
          <span class="file-name">{{ formatFileName(result.fileName) }}</span>
          <span class="line-number">第 {{ result.lineNumber }} 行</span>
        </div>
        <div class="result-content" v-html="highlightContent(result.content)"></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { highlightSearchResult } from '@/utils/sanitize'

export default {
  name: 'SearchResults',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    results: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  emits: ['update:visible'],
  setup(props, { emit }) {
    const store = useStore()
    const searchQuery = computed(() => store.state.searchQuery)
    
    const dialogVisible = computed({
      get: () => props.visible,
      set: (value) => emit('update:visible', value)
    })

    const handleClose = () => {
      dialogVisible.value = false
    }

    const formatFileName = (fileName) => {
      if (!fileName) return ''
      
      // 文件扩展名本地化映射表
      const extensionMap = {
        '.analysis.json': '.解析',
        '.term.json': '.术语',
        '.machinetranslation.json': '.译文',
        '.mytrans.json': '.译文',
        '.score.json': '.评分',
        '.json': '.原文'
      }
      
      // 替换已知的扩展名
      let localizedName = fileName
      for (const [eng, chn] of Object.entries(extensionMap)) {
        if (localizedName.toLowerCase().endsWith(eng)) {
          localizedName = localizedName.substring(0, localizedName.length - eng.length) + chn
          break
        }
      }
      
      return localizedName
    }

    const highlightContent = (content) => {
      return highlightSearchResult(content, searchQuery.value)
    }

    return {
      dialogVisible,
      handleClose,
      highlightContent,
      formatFileName
    }
  }
}
</script>

<style scoped>
.search-results {
  max-height: 60vh;
  overflow-y: auto;
  padding: 10px;
}

.no-results {
  text-align: center;
  color: #909399;
  padding: 20px;
  font-size: 14px;
}

.result-item {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  transition: all 0.3s;
}

.result-item:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.file-name {
  font-weight: bold;
  color: #409eff;
  font-size: 14px;
}

.line-number {
  color: #909399;
  font-size: 13px;
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 3px;
}

.result-content {
  background-color: #f5f7fa;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 10px;
  white-space: pre-wrap;
  word-break: break-all;
  font-family: "Microsoft YaHei", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #606266;
}

:deep(.highlight) {
  background-color: #ffd04b;
  padding: 0 2px;
  border-radius: 2px;
  font-weight: bold;
  color: #000;
}

:deep(.el-dialog__body) {
  padding: 0;
}

:deep(.el-dialog__header) {
  padding: 15px 20px;
  margin-right: 0;
  border-bottom: 1px solid #e8e8e8;
}

/* 自定义滚动条样式 */
.search-results::-webkit-scrollbar {
  width: 6px;
}

.search-results::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

.search-results::-webkit-scrollbar-track {
  background: #f5f5f5;
}
</style> 